"use client";
import { jsx } from "react/jsx-runtime";
import { createContext } from "react";
const ProductTileDataContext = createContext(null);
const ProductTileProvider = ({
  value,
  children
}) => {
  return /* @__PURE__ */ jsx(ProductTileDataContext.Provider, { value, children });
};
export {
  ProductTileDataContext,
  ProductTileProvider
};
